import api from './api';
import store from "@/store"
import router from "@/router"

class UserService {
  async getAccounts() {
    let userUuid = store.state.profil.user
    if(userUuid) {
        return await api.get('/user/' + userUuid + '/accounts')
    }
  }

  async getPermission(accountUuid) {
    let userUuid = store.state.profil.user
    if(userUuid) {
        return await api.get('/user/' + userUuid + '/account/' + accountUuid + '/permission')
          .then(response => response.data)
    }
  }

  async getPermissionByPersonGroup(personGroupUuid) {
    let userUuid = store.state.profil.user
    if(userUuid) {
        return await api.get('/user/' + userUuid + '/person-group/' + personGroupUuid + '/permission')
          .then(response => response.data)
    }
  }

  async getAccountsGroupRoot() {
    let userUuid = store.state.profil.user
    if(userUuid) {
        return await api.get('/user/' + userUuid + '/account_group_root').then(response => response.data)
    }
  }

  async getPersonGroup() {
    let userUuid = store.state.profil.user
    if(userUuid) {
        return await api.get('/user/' + userUuid + '/person-group').then(response => response.data)
    }
  }

  hasPermission(right) {
    if(store.state.account.permissions == 'owner') {
      return true
    } else if(store.state.account.permissions[right] == 'T') {
      return true
    }

    return false
  }

  async close(userUuid) {
    return await api.patch('/user/' + userUuid + '/close')
          .then(response => {
            store.dispatch('auth/logout')

            router.push({name: 'login'})

            return response.data
          })
  }
}

export default new UserService();
